<template>
  <nav>
    <v-row
      class="fill-height"
      align="center"
      v-if="!loadingData"
    >
      <v-col
        cols="12"
        sm="8"
        md="6"
        offset-sm="2"
        offset-md="3"
        align="center"
      >
        <AlertMessages
          v-if="alertValue"
          :alert-type="alertType" 
          :alert-msg="alertMsg"
          @reset="alertValue = false"
        />
        <v-card
          max-width="800"
          elevation="0"
          rounded="xxl"
          color="background"
        > 
          <v-card-title class="text-h5 font-weight-bold text-center justify-center mb-4 no-break">
            {{ $t('connectedHubsTitle') }}
          </v-card-title>
          <v-card-subtitle class="text-body-1 darktext--text no-break" v-if="hubs.length">
            {{ $t('connectedHubsDescription') }}
          </v-card-subtitle>
          <div v-if="!hubs.length" class="connected-hubs-empty-list" data-testid="empty-connected-hubs-list"> 
            <v-row
              no-gutters
              align="center"
              class="fill-height"
            >
              <v-col
                cols="12"
                class="mx-auto pa-0"
                align="center"
              > 
                <div class="greytextlight--text text-h6 text-md-h5 font-weight-bold mx-auto pa-4">
                  {{ $t('autoSharingNoHubs') }}
                </div>               
              </v-col>
            </v-row>
          </div>
            <div v-else class="pa-5" data-testid="connected-hubs-list">
              <div v-if="hubsOwnerIn.length"  class="mb-4">
                <p class="text-body-1 darktext--text font-weight-bold mb-0" align="left">{{ $t('autoSharingHubsOwnerTitle') }}:</p>
                <v-divider />
                <v-list color="background">
                  <v-list-item
                    v-for="hub in hubsOwnerIn"
                    :key="hub.id"
                    align="left"
                  >
                  <v-list-item-content>
                    <v-list-item-title>
                      <router-link :to="{ path: '/hub/' + hub.id}" target="_blank">
                        {{ hub.attributes.title}}
                      </router-link>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </div>
            <div v-if="hubsNotOwnerIn.length">
              <p class="text-body-1 darktext--text font-weight-bold mb-0" align="left">{{ $t('autoSharingHubsNotOwnerTitle') }}:</p>
              <v-divider />
              <v-list color="background">
                  <v-list-item
                    v-for="hub in hubsNotOwnerIn"
                    :key="hub.id"
                    align="left"
                  >
                  <v-list-item-content>
                    <v-list-item-title>
                      <span class="greytextlight--text">{{ hub.attributes.title}}</span>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </div>
          </div>
        </v-card>
        <v-row>
          <v-col align="center">
            <FormFooter
              :cancel-button-link="cancelLink"
              :hide-submit="true"
              cancel-button-text="back"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>          
  </nav>
</template>
<script>
import i18n from '../../plugins/i18n'
import AlertMessages  from '../../components/AlertMessages'
import { getActivity } from '../../api/activityApi'
import FormFooter  from '../../components/FormFooter'

export default {
    components: {
        AlertMessages,
        FormFooter
    },
    data () {
        return {
            spaceId: window.$cookies.get('space_id'),
            alertMsg:'',
            alertValue:false,
            valid: true,
            activityId: this.$route.params.id,
            cancelLink: '/activity/'+this.$route.params.id,
            isAutoSharedWithHubMembers: false,
            hubs: [],
            loadingData: false
        }
    },
    beforeRouteEnter(to, from, next) {
        if(from.path != null && from.path != '/redirect' && from.path != '/'){
            next(vm => {
                vm.cancelLink = from.path
            });
        }else { 
            next();
        }
    },
    computed: {
        hubsOwnerIn() {
            return this.hubs.filter((item) =>{
                return item.meta.role == 'Booster'
            });
        },
        hubsNotOwnerIn() {
            return this.hubs.filter((item) =>{
                return item.meta.role != 'Booster'
            });
        },  
    },
    watch: {
        
    },
    async created(){
        this.loadingData = true
        await this.getActivity()

        this.loadingData = false
    },
    methods: {
        async getActivity(){
            try {
                const response = await getActivity(this.activityId)
                if(response.status == 200) {
                    //autosharing with hub members
                    if(response.data.data.relationships.hubs){
                      this.isAutoSharedWithHubMembers = true
                      this.hubs = response.data.data.relationships.hubs.meta.data
                      //to make both arrays to not be reactive to changes (when only one array is changed)
                      //solution: https://stackoverflow.com/questions/58258270/vuejs-how-to-assign-an-array-to-another-array-in-such-a-way-that-the-two-arrays
                      //this.hubs = JSON.parse(JSON.stringify(response.data.data.relationships.hubs.meta.data))
                      //this.initialHubsState = JSON.parse(JSON.stringify(response.data.data.relationships.hubs.meta.data))
                    }
                }  
            } catch (e) {
                if(e.response){
                  if(e.response.status != 401 && e.response.status != 404){
                    this.alertValue = true
                    this.alertType = 'error'
                    this.alertMsg =  i18n.t('serverError')
                  }
                } 
            }
        }
    }
}

</script>